import { styled } from "@linaria/react"
import { runInAction } from "mobx"
import { useCallback, useContext } from "react"

import { AgentMessageContainer } from "@/components/Chat/AgentMessageStyles.ts"
import { MessageText } from "@/components/Chat/MessageStyles.ts"
import { Horizontal, Vertical } from "@/components/Flex.ts"
import { GenerateLight, Icon20 } from "@/icons/Icons.ts"
import { TaskViewModelContext } from "@/routes/tasks/TaskViewScene/TaskViewModel.ts"
import * as textStyles from "@/styles/textStyles.ts"

import type { AiChatMessageContent } from "@/lib/client/generated/TypeDefinitions.ts"

export const FirstTaskGreetingMessage = (props: {
  content: AiChatMessageContent.FirstTaskGreeting,
  isLast: boolean
}) => {
  const taskViewModel = useContext(TaskViewModelContext)

  const chooseIdea = useCallback((idea: string) => {
    const inputModel = taskViewModel?.inputModel
    if (!inputModel || inputModel?.readOnly.get() || inputModel?.isSubmitting.get()) {
      return
    }

    const inputModes = inputModel.supportedInputModes.get().map(it => it.type)
    if (!inputModes.includes("Chat")) {
      return
    }

    inputModel.setInputMode("Chat")
    runInAction(() => {
      if (!inputModel.readOnly.get() && !inputModel.isSubmitting.get()) {
        void inputModel.submitPrompt(idea)
      }
    })
  }, [taskViewModel])

  return (
    <AgentMessageContainer isActive={true}>
      <Vertical gap="16px">
        <MessageText>
          Welcome to {taskViewModel?.projectName?.get()} in Matter! Here are some ideas to start with or describe what you’d like to work on.
        </MessageText>

        <Vertical gap="12px">
          {props.content.ideas.map((idea, index) => (
            <IdeaContainer key={index} data-expanded={true} onClick={(e) => {
              e.stopPropagation()
              chooseIdea(idea)
            }}>
              <GenerateLight className={Icon20} />
              <div>
                {idea}
              </div>
            </IdeaContainer>
          ))}
        </Vertical>
      </Vertical>
    </AgentMessageContainer>
  )
}

const IdeaContainer = styled(Horizontal)`
  align-items: center;
  gap: 12px;
  padding: 16px;
  border-radius: 16px;
  border: 0;
  box-shadow: 0 2px 12px 0 var(--text-color-10);

  background: linear-gradient(0deg, rgb(85 85 255 / 10%), rgb(85 85 255 / 10%)),
    linear-gradient(0deg, rgb(85 85 255 / 5%), rgb(85 85 255 / 5%));

  ${textStyles.baseFontSize};
  ${textStyles.breakWord};
  font-weight: 500;

  color: rgb(85 85 255);

  cursor: pointer;
`
